var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-station-detail" }, [
    _c(
      "button",
      {
        staticClass: "button-back",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.back.apply(null, arguments)
          }
        }
      },
      [
        _c("svg", { staticClass: "icon icon_arrow" }, [
          _c("use", { attrs: { "xlink:href": "#icon_arrow" } })
        ]),
        _vm._v("\n\t\tTerug naar alle stations\n\t")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-controller" },
      [
        _c("h2", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _vm._l(_vm.slides, function(slide) {
          return !_vm.loading
            ? _c("StationSlide", {
                key: slide.uuid,
                attrs: { slide: slide, currentSlide: _vm.currentSlide },
                on: { next: _vm.nextSlide, activate: _vm.setSlide }
              })
            : _vm._e()
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }